function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}

/** Payload of `get_custom_report_info`: which parameter dialog a custom report
 *  needs, the config it runs against, and its template path (Excel vs XML). */
export interface CustomReportInfo {
  model_name: string;
  report_config_name: string;
  report_file: string;
}

export async function fetchCustomReportInfo(
  configName: string,
  reportName: string,
): Promise<CustomReportInfo> {
  if (isTauri()) {
    const { invoke } = await import("@tauri-apps/api/core");
    return await invoke<CustomReportInfo>("get_custom_report_info", { configName, reportName });
  }
  const url = `/api/get_custom_report_info?config_name=${encodeURIComponent(configName)}&report_name=${encodeURIComponent(reportName)}`;
  const response = await fetch(url);
  if (!response.ok) throw new Error(`fetchCustomReportInfo failed: ${response.status}`);
  return (await response.json()) as CustomReportInfo;
}
